<template>
  <div v-if="languageFlag" class="langaugeSelectorAuto">
    <div class="header__logo">
      <a href="/" :aria-label="ariaLabel" class="logo"
        ><svg
          width="681"
          height="264"
          viewBox="0 0 681 264"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          role="img"
          :aria-label="ariaLabel"
        >
          <g clip-path="url(#clip0_506_2850)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M680.787 207.368H340.449H0.102753V172.109V136.858H340.449H680.787V172.109V207.368Z"
              fill="black"
            />
            <path
              d="M427.007 235.384L420.739 239.333C418.811 236.253 415.048 234.42 410.132 234.42C405.698 234.42 402.417 235.865 402.417 238.18C402.417 240.976 406.18 241.647 410.709 242.516L415.728 243.385C421.704 244.443 427.395 246.465 427.395 252.926C427.395 261.212 418.044 264.008 409.65 264.008C402.994 264.008 396.055 261.599 392.102 256.876L398.663 253.021C401.556 256.489 405.895 258.124 410.914 258.124C414.574 258.124 419.498 257.065 419.498 253.787C419.498 251.189 416.51 250.415 411.104 249.356L406.575 248.487C400.117 247.239 394.426 245.304 394.426 239.143C394.426 232.011 402.623 228.544 410.14 228.544C417.088 228.544 422.771 230.763 427.015 235.384"
              fill="black"
            />
            <path
              d="M382.364 229.412H374.745V263.139H382.364V229.412Z"
              fill="black"
            />
            <path
              d="M355.459 249.546L364.422 263.131H355.648L347.839 250.699H340.512V263.131H332.892V229.405H349.768C358.352 229.405 363.458 233.741 363.458 239.617C363.458 247.231 357.387 248.961 355.459 249.538M348.803 245.202C352.661 245.202 355.459 243.274 355.459 240.091C355.459 236.908 352.953 235.076 347.649 235.076H340.512V245.194H348.803V245.202Z"
              fill="black"
            />
            <path
              d="M310.041 229.412L323.636 263.139H315.63L313.314 256.583H297.979L295.664 263.139H287.657L301.157 229.412H310.025H310.041ZM311.195 250.999L305.702 235.581H305.607L300.011 250.999H311.195Z"
              fill="black"
            />
            <path
              d="M281.207 240.778C281.207 247.429 275.611 251.765 267.612 251.765H258.64V263.139H251.029V229.412H267.129C276.583 229.412 281.207 234.325 281.207 240.786M266.165 246.473C270.987 246.473 273.303 244.064 273.303 240.786C273.303 236.158 270.212 234.72 265.873 234.72H258.64V246.473H266.165Z"
              fill="black"
            />
            <path
              d="M370.477 114.813H458.371V104.11H385.558V69.7676H440.223V58.9151H385.558V27.3131H458.371V16.6185H370.477V114.813Z"
              fill="black"
            />
            <path
              d="M416.163 0.766113L404.235 14.1225L441.598 0.766113H416.163Z"
              fill="black"
            />
            <path
              d="M605.895 104.11V16.6185H592.157V114.813H681V104.11H605.895Z"
              fill="black"
            />
            <path
              d="M515.321 16.6185L465.342 114.813H482.21L495.007 89.4034H554.96L567.836 114.813H584.577L534.551 16.6185H515.321ZM501.33 77.1054L524.9 30.1882L548.724 77.1054H501.33Z"
              fill="black"
            />
            <path
              d="M322.783 73.7722C345.326 67.7298 347.491 51.0086 347.404 45.0374C346.068 27.4948 334.22 16.6106 312.958 16.6106H251.037V114.805H265.138V73.6221H305.473L335.145 114.805H352.937C352.937 114.805 331.58 87.0575 322.791 73.7643M311.045 62.0192H265.138V28.2609H312.642C323.565 28.2609 329.715 33.3554 331.952 39.8243C333.398 44.2712 332.481 50.0924 330.047 54.0654C326.095 60.6211 318.538 62.0271 311.045 62.0271"
              fill="black"
            />
            <path
              d="M166.154 0C126.309 0 99.15 28.0555 99.15 62.0823C99.15 97.8626 129.146 123.106 166.154 123.106C203.161 123.106 233.165 98.2023 233.165 62.0823C233.165 28.0555 205.651 0 166.154 0ZM165.687 110.919C138.11 110.919 115.393 88.7714 115.393 62.0902C115.393 35.409 137.043 12.2427 166.754 12.2427C196.466 12.2427 217.049 35.4564 217.049 62.0902C217.049 88.724 193.249 110.919 165.687 110.919Z"
              fill="black"
            />
            <path
              d="M63.5417 51.3483H73.7697L92.2575 16.6185H77.374L63.5417 51.3483Z"
              fill="black"
            />
            <path
              d="M13.7533 104.11V16.6185H0V114.813H88.8587V104.11H13.7533Z"
              fill="black"
            />
          </g>
          <g>
            <path
              d="M41.3863 180.592V191.239H32.992V153.595H50.7527C60.38 153.595 65.1778 159.834 65.1778 167.093C65.1778 174.352 60.3326 180.481 50.7527 180.592H41.3863ZM41.3863 172.899H50.7527C54.7917 172.899 56.7757 170.26 56.7757 167.251C56.7757 164.242 54.7285 161.548 50.7527 161.548H41.3863V172.899Z"
              fill="white"
            />
            <path
              d="M116.421 191.239H107.109L97.4743 178.87H91.396V191.239H83.0017V153.595H100.865C109.963 153.595 114.8 159.668 114.8 166.287C114.745 171.185 113.291 175.537 106.082 178.119L116.413 190.599V191.247L116.421 191.239ZM91.396 160.806V171.777H100.976C104.849 171.777 106.517 168.87 106.517 166.509C106.461 163.926 104.794 160.806 100.865 160.806H91.396Z"
              fill="white"
            />
            <path
              d="M152.329 192.155C140.275 192.155 131.992 184.683 131.992 172.417C131.992 160.15 140.275 152.678 152.329 152.678C164.383 152.678 172.667 160.15 172.667 172.417C172.667 184.683 164.383 192.155 152.329 192.155ZM152.329 160.214C145.168 160.214 140.22 165.592 140.22 172.425C140.22 179.257 145.168 184.58 152.329 184.58C159.49 184.58 164.438 179.415 164.438 172.425C164.438 165.434 159.649 160.214 152.329 160.214Z"
              fill="white"
            />
            <path
              d="M191.305 191.239V153.65H218.748V161.343H199.699V170.268H217.57V177.74H199.699V191.239H191.305Z"
              fill="white"
            />
            <path
              d="M266.07 191.239H237.386V153.595H265.319V161.288H245.622V168.546H264.189V175.916H245.622V183.498H266.07V191.239Z"
              fill="white"
            />
            <path
              d="M307.362 162.686C305.267 160.482 301.608 159.511 298.643 159.511C294.928 159.511 291.917 161.067 291.917 163.649C291.917 167.093 295.197 167.741 300.042 168.167C307.465 168.815 314.515 171.666 314.515 180.371C314.515 189.075 306.769 192.416 298.636 192.471C292.123 192.526 285.349 189.999 282.171 184.731L287.174 179.518C290.075 183.23 294.873 184.841 298.691 184.841C303.157 184.841 306.224 183.064 306.224 180.378C306.279 177.203 303.75 175.758 298.636 175.323C290.676 174.573 283.57 172.583 283.673 163.705C283.728 156.233 290.826 152.252 298.58 152.252C304.398 152.252 308.753 153.539 312.626 158.057L307.354 162.678L307.362 162.686Z"
              fill="white"
            />
            <path
              d="M354.945 162.686C352.85 160.482 349.191 159.511 346.227 159.511C342.512 159.511 339.5 161.067 339.5 163.649C339.5 167.093 342.78 167.741 347.626 168.167C355.048 168.815 362.098 171.666 362.098 180.371C362.098 189.075 354.352 192.416 346.227 192.471C339.714 192.526 332.94 189.999 329.762 184.731L334.766 179.518C337.666 183.23 342.464 184.841 346.282 184.841C350.748 184.841 353.815 183.064 353.815 180.378C353.87 177.203 351.341 175.758 346.227 175.323C338.267 174.573 331.161 172.583 331.264 163.705C331.319 156.233 338.417 152.252 346.171 152.252C351.989 152.252 356.344 153.539 360.217 158.057L354.945 162.678V162.686Z"
              fill="white"
            />
            <path
              d="M380.254 191.239V153.595H388.593V191.239H380.254Z"
              fill="white"
            />
            <path
              d="M427.561 192.155C415.507 192.155 407.223 184.683 407.223 172.417C407.223 160.15 415.507 152.678 427.561 152.678C439.614 152.678 447.898 160.15 447.898 172.417C447.898 184.683 439.614 192.155 427.561 192.155ZM427.561 160.214C420.399 160.214 415.451 165.592 415.451 172.425C415.451 179.257 420.399 184.58 427.561 184.58C434.722 184.58 439.67 179.415 439.67 172.425C439.67 165.434 434.88 160.214 427.561 160.214Z"
              fill="white"
            />
            <path
              d="M492.746 178.064L492.209 166.232V153.595H500.658V191.239H493.45L474.725 167.148L475.049 179.517V191.239H466.544V153.595H473.753L492.746 178.064Z"
              fill="white"
            />
            <path
              d="M547.601 178.064L547.064 166.232V153.595H555.513V191.239H548.305L529.58 167.148L529.904 179.517V191.239H521.399V153.595H528.608L547.601 178.064Z"
              fill="white"
            />
            <path
              d="M604.986 191.239H576.301V153.595H604.235V161.288H584.537V168.546H603.104V175.916H584.537V183.498H604.986V191.239Z"
              fill="white"
            />
            <path
              d="M632.389 153.595V183.546H651.225V191.239H623.995V153.595H632.389Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_506_2850">
              <rect width="681" height="264" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </a>
    </div>
    <div class="desc">{{ items.title }}{{ items.description }}</div>
    <div class="content">
      <div class="btnBlock">
        <button class="yesBtn" @click="autoRedirect">
          {{ items.leavebuttontext }}
        </button>
        <button class="noBtn" @click="autoRedirect">
          {{ items.staybuttontext }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { setCookie } from 'Utils/common';
export default {
  name: 'language-selector-auto',
  props: {
    items: {
      type: Object,
      required: true,
      default: [],
    },
    ariaLabel: {
      type: String,
      required: true,
      default: 'L&#x27;Oréal Professionnel Paris',
    },
  },
  data() {
    return {
      languageFlag: true,
    };
  },
  mounted() {
    this.checkCookie();
    this.hidePage();
  },
  methods: {
    hidePage() {
      document.querySelectorAll('div').forEach((item) => {
        if (item.classList.contains('langaugeSelectorAuto')) {
          document.querySelector('header').style.display = 'none';
          document.querySelector('#widget_weact_watersaver').style.display =
            'none';
        } else {
          document.querySelector('header').style.display = 'block';
          document.querySelector('#widget_weact_watersaver').style.display =
            'block';
        }
      });
    },
    autoRedirect(e) {
      if (e.target.innerText == this.items.leavebuttontext) {
        window.location.assign(this.items.leavebuttonlink);
        this.languageFlag = false;
        setCookie('languageFlag', this.languageFlag, this.items.cookielifetime);
      } else if (e.target.innerText == this.items.staybuttontext) {
        window.location.assign(this.items.staybuttonlink);
        this.languageFlag = false;
        setCookie('languageFlag', this.languageFlag, this.items.cookielifetime);
      }
    },

    checkCookie() {
      let cookies = document.cookie
        .split(';')
        .map((cookie) => cookie.split('='))
        .reduce(
          (accumulator, [key, value]) => ({
            ...accumulator,
            [key.trim()]: decodeURIComponent(value),
          }),
          {}
        );

      if (cookies.languageFlag == 'false') {
        this.languageFlag = false;
      }
    },
  },
};
</script>
